/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FlipNamespaceRelationshipPayload = {
    childNamespaceId: string;
    parentNamespaceId: string;
    cardinality: FlipNamespaceRelationshipPayload.cardinality;
};

export namespace FlipNamespaceRelationshipPayload {

    export enum cardinality {
        SINGLE = 'single',
        MULTIPLE = 'multiple',
    }


}

